import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";
import { StateService, WizardAnswers } from "./state.service";

@Injectable({
  providedIn: "root",
})
export class ShareService {
  private readonly ENCRYPTION_KEY = "frontend_secret_key_for_pilot";

  constructor(private stateService: StateService) {}

  /**
   * Genereert een deelbare URL met de huidige wizardantwoorden.
   */
  generateAdviesShareLink(): string {
    const currentAnswers = this.stateService.getAnswers();
    const serializedAnswers = JSON.stringify(currentAnswers);
    const encryptedAndEncodedData = this.encryptData(serializedAnswers);

    return `${window.location.origin}/advies?data=${encodeURIComponent(encryptedAndEncodedData)}`;
  }

  /**
   * Laadt en verwerkt antwoorden vanuit een versleutelde en gecodeerde URL-parameter.
   * Retourneert true bij succes, false bij fout.
   */
  loadAnswersFromShareLink(encodedAndEncryptedData: string): boolean {
    try {
      const decryptedJson = this.decryptData(encodedAndEncryptedData);
      const loadedAnswers: WizardAnswers = JSON.parse(decryptedJson);
      this.stateService.setAllAnswers(loadedAnswers);
      return true;
    } catch (e) {
      console.error("Fout bij het laden/ontsleutelen van antwoorden uit URL:", e);
      return false;
    }
  }

  private encryptData(data: string): string {
    const ciphertext = CryptoJS.AES.encrypt(data, this.ENCRYPTION_KEY).toString();
    return btoa(ciphertext);
  }

  private decryptData(encodedAndEncryptedData: string): string {
    const decodedCiphertext = atob(encodedAndEncryptedData);
    const bytes = CryptoJS.AES.decrypt(decodedCiphertext, this.ENCRYPTION_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  }
}
